// extracted by mini-css-extract-plugin
export default {"panel":"PointMatrixScoreTable_panel__cWB7r","button":"PointMatrixScoreTable_button__tFGcW"};